import React from 'react';
import { ConfigClientType } from '../types/ConfigClientType';
import { isSwedish } from '../../constants/languages';
import { getTranslation } from '../../constants/languages';
import { getPageExceptionTranslation } from '../../constants/siteIds';

type CallHeaderProps = {
  iimclient: ConfigClientType;
};

const Translations = {
  lang_no: 'Ring oss',
  lang_se: 'Ring',
  lang_dk: 'Ring til Kundeservice',
  lang_fi: 'Soita',
  lang_en: 'Call'
}

const PageExceptions = {
  fiwebshop: null,
  secom: null,
  secombroker: null,
  secomclaims: null,
  secommotorclaims: null,
  sebreeders: null,
  seanimal: null,
  dkcom: 'Ring til os',
  dkkvalitet: 'Ring om Betaling',
  dksalessupport: 'Ring til Salessupport',
}

const CallHeader = ({ iimclient }: CallHeaderProps) => {
  const { lang, segment } = iimclient;
  const useCallHeaderText = !isSwedish(iimclient) || !segment;
  const translation = getPageExceptionTranslation(iimclient, PageExceptions) || getTranslation(lang, Translations);

  return (
    <span className="heading call-header" id="call-header">
      {useCallHeaderText && translation}
    </span>
  );
};

export default CallHeader;
